export default function isStandardGame(
  eventType: string | null | undefined,
  teamCount: number | undefined,
) {
  return eventType === 'game' && teamCount === 2;
}
